import Box from "@mui/material/Box";
import BoxContent from "shared/ui/BoxContent";
import PageTitle from "shared/ui/PageTitle";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import {useRouteMatch} from "utils/functions";
import GenericButton from "shared/ui/GenericButton";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Classrooms from "../components/Classrooms";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const ClassroomsPage = () => {
    const { user, tenant } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab = useRouteMatch(["/clase", "/clase/arhiva"]);
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Box>
            <PageTitle
                actions={
                    <GenericButton
                        type="add"
                        onClick={() => {
                            navigate(`/clase/adauga`);
                        }}
                    />
                }
            >
                Clase
            </PageTitle>
            <BoxContent>
                <>
                    {(user.position === "principal" || (tenant.type === "teacher" && user.position === "teacher")) && (
                        <Box sx={{width: "100%"}}>
                            <Box mb={2} sx={{borderBottom: 1, borderColor: "divider"}}>
                                <Tabs
                                    value={currentTab}
                                    variant="scrollable"
                                    scrollButtons={!isSmUp}
                                    allowScrollButtonsMobile
                                >
                                    <Tab label="Clase active" value="/clase" to="/clase" component={Link}/>
                                    <Tab
                                        label="Clase arhivate"
                                        value="/clase/arhiva"
                                        to="/clase/arhiva"
                                        component={Link}
                                    />
                                </Tabs>
                            </Box>
                            {location.pathname === "/clase" && <Classrooms isArchived={false}/>}
                            {location.pathname === "/clase/arhiva" && <Classrooms isArchived={true}/>}
                        </Box>
                    )}
                    {(tenant.type === "school" && user.position === "teacher") && (
                        <Box sx={{width: "100%"}}>
                            {location.pathname === "/clase" && <Classrooms isArchived={false}/>}
                        </Box>
                    )}
                </>
            </BoxContent>
        </Box>
    );
};

export default ClassroomsPage;
